<template>
  <div class="index" @click="goNext()" v-bind:style="{backgroundImage:'url(' + bg_img + ')'}">
      <h3 class="title animated fadeInDownBig"><span>产品及服务</span></h3>
      <h3 class="animated fadeInDownBig">特色产品  贴心服务</h3>
      <img class="index-bottom animated fadeInUp" src="https://cdn.hanlandglobal.com/h5-service2-bg.png" />
      <img class="marker animated fadeIn" src="../assets/image/h5-service-maker.png" />
      <img ref="gif" class="gif-img animated fadeIn" :src="gif" /> 
  </div>
</template>

<script>
// @ is an alias to /src
import bg_img from '../assets/image/h5-bg.png'
import gif from '../assets/image/shouzhi.gif'

export default {
  name: 'Home',
  data(){
    return {
      bg_img,
      gif
    }
  },
  mounted(){

  },
  methods:{
    goNext(){
      this.$router.push('/partner')
    }
  }
}
</script>
<style lang='scss' scoped>
.index{
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  position: relative;
}
.title{
  padding-top:11.5vh;
  animation-delay: 0.5s;
}
h3{
  font-size: 0.36rem;
  font-family: SourceHan;
  color: #4d372e;
  font-weight: normal;
  text-align: center;
  letter-spacing: 1px;
  span{
    font-size: 0.54rem;
    font-weight: 700;
  }
}
.index-bottom{
  width: 100%;
  max-height: 6.35rem;
  position: absolute;
  left: 0;
  bottom: 0;
  animation-duration: 1.5s;
}
.marker{
  width: 6.92rem;
  height: 5.79rem;
  position: absolute;
  left: 0.1rem;
  bottom:2.4rem;
  z-index: 99;
  animation-duration: 1s;
  animation-delay: 1.5s; 
}
.gif-img{
  position:absolute;
  width: 2.7rem;
  height: 1.98rem;
  z-index: 999;
  bottom: 2.3rem;
  right: 1.2rem;
  animation-delay: 0.8s; 
}

</style>
